<template>
    <VJoyIconButton size="small" variant="ghost" icon="sort" :label="t('profile.section.experiences.sort.title')" @click="sortExperiencesByDate" />
</template>
<script setup lang="ts">
    import {storeToRefs, useTranslation} from '#imports';
    import {pushVJoySnackbar, VJoyIconButton} from '@maltjoy/core-vue';
    import {eventBus} from '~/config/events';
    import {useProfileStore} from '~/store/profileStore';
    import {experienceMapper} from '~/types/infra/ExperienceMapper';

    // Composables
    const {t} = useTranslation();

    // Stores
    const {reorderExperiences} = useProfileStore();
    const {experiences} = storeToRefs(useProfileStore());

    // Handlers
    async function sortExperiencesByDate() {
        const allExperiences = experiences.value?.items.map((experience, index) => experienceMapper.toRequest(experience, index)) || [];

        try {
            allExperiences.sort(experienceMapper.sortByDate);
            const experienceIds = allExperiences.map((experience) => experience.id as string);
            await reorderExperiences(experienceIds);
            eventBus.emit('experiences:updated');
            pushVJoySnackbar({
                props: {
                    message: t('profile.section.experiences.sort.success'),
                    level: 'success',
                },
            });
        } catch (e) {
            pushVJoySnackbar({
                props: {
                    message: t('profile.section.experiences.sort.error'),
                    level: 'error',
                },
            });
        }
    }
</script>
